document.addEventListener('DOMContentLoaded', () => {
 // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }

  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', (e) => this.openPopup(e));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', (e) => this.openPopup(e));
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      this.popupTemplate = popupTemplate;
      this.popupClass = popupClass;
      this.closeBtnClass = closeBtnClass;
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-close').classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.querySelector('.yg-popup-box-content-inner').innerHTML = popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        this.querySelector('.yg-popup-box-close').classList.remove(`${closeBtnClass}`)
        this.classList.remove(`${popupClass}`)
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    get getCurrentSlidesPerView() {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'centered-slides', 'mousewheel','direction','scrollbar','progressbar','grid'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        loopAdditionalSlides: this['loop'] ? 2 : 0,
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          type: this['progressbar']?'progressbar':'bullets',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        } : false,    
        scrollbar: this['scrollbar']?{
          el: ".swiper-scrollbar",
          hide: true,
        }:false,
        grid: this['grid']?{
          fill: 'row',
          rows: 2,
        }:false,
        breakpoints: this['breakpoints']?this['breakpoints']:false,
        mousewheel: this['mousewheel']?{
          releaseOnEdges: true,
        }:false,
        direction: this['direction']?this['direction']:"horizontal",
        watchSlidesProgress: true,
        on: {
          init: e => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 2;
              }

              // 考虑 overflow: visible 的情况，确保有足够的克隆slides
              const minRequiredSlides = Math.ceil(num * 2.5) + 2;
              
              if (sliderLength < minRequiredSlides) {
                const timesToClone = Math.ceil(minRequiredSlides / sliderLength);
                
                for (let index = 1; index < timesToClone; index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  })
                }

                // 重新初始化 swiper 以识别新添加的 slides
                setTimeout(() => {
                  e.update();
                  e.loopFix();
                  
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  })
                }, 250)
              }
            }
          }
        }
      })
    }
    
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGImageCard extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 14,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  }

  if (!window.customElements.get('yg-image-card')) {
    window.customElements.define('yg-image-card', YGImageCard);
  }

  class YGProductTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabButtons = this.querySelectorAll('.tab-button');
      this.tabContainers = this.querySelectorAll('.yg-image-card-container');
      
      this.init();
    }

    init() {
      // 默认显示第一个tab的内容
      if (this.tabButtons.length > 0) {
        this.tabButtons[0].classList.add('active');
        const firstTabNumber = this.tabButtons[0].dataset.tab;
        this.tabContainers.forEach((container) => {
          if (container.dataset.tab === firstTabNumber) {
            container.classList.add('active');
          }
        });
      }

      // 为每个tab按钮添加点击事件
      this.tabButtons.forEach((button) => {
        button.addEventListener('click', (e) => this.handleTabClick(e));
      });
    }

    handleTabClick(event) {
      const button = event.currentTarget;
      const tabNumber = button.dataset.tab;

      // 移除所有active类
      this.tabButtons.forEach((btn) => btn.classList.remove('active'));
      this.tabContainers.forEach((container) => container.classList.remove('active'));

      // 添加active类到当前选中的tab和对应的内容
      button.classList.add('active');
      this.tabContainers.forEach((container) => {
        if (container.dataset.tab === tabNumber) {
          container.classList.add('active');
        }
      });
    }
  }

  // 注册自定义元素
  if (!window.customElements.get('yg-product-tabs')) {
    window.customElements.define('yg-product-tabs', YGProductTabs);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const header = this.querySelector('.yg-accordion-header');
      const content = this.querySelector('.yg-accordion-content');
      const hasParentAccordion = this.parentNode.closest('.yg-accordion');
      const isInFilterWrapper = this.closest('.yg-installation-filter-wrapper') || this.closest('.yg-filter-body');
      
      const contentHeight = content.scrollHeight;
      this.style.setProperty('--content-height', `${contentHeight}px`);

      if(isInFilterWrapper) {
        header.classList.add('active');
        content.classList.add('active');

        if(hasParentAccordion) {
          
          const originalContentHeight = hasParentAccordion.style.getPropertyValue('--content-height').replace('px', '');
          console.log(originalContentHeight,'originalContentHeight');
          
          if(originalContentHeight) {
            console.log('contentHeight',contentHeight);
            console.log('originalContentHeight + contentHeight',originalContentHeight + contentHeight);
            hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            if(header.classList.contains('active')) {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            } else {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) - Number(contentHeight)}px`);
            }
          } else {
            hasParentAccordion.style.setProperty('--content-height', `${Number(contentHeight)}px`);
          }
        }
      }

      header.addEventListener('click', () => {
        header.classList.toggle('active');
        content.classList.toggle('active');
        if(hasParentAccordion) {
          
          const originalContentHeight = hasParentAccordion.style.getPropertyValue('--content-height').replace('px', '');
          console.log(originalContentHeight,'originalContentHeight');
          
          if(originalContentHeight) {
            console.log('contentHeight',contentHeight);
            console.log('originalContentHeight + contentHeight',originalContentHeight + contentHeight);
            hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            if(header.classList.contains('active')) {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            } else {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) - Number(contentHeight)}px`);
            }
          } else {
            hasParentAccordion.style.setProperty('--content-height', `${Number(contentHeight)}px`);
          }
        }
      });
    }
  }

  if (!window.customElements.get('yg-accordion')) {
    window.customElements.define('yg-accordion', YGAccordion);
  }

  class YGDownload extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    init() {
      this.addEventListener('click', this.handleDownloadClick.bind(this));
    }

    fileDownload(url, name) {
      this.classList.add('active');
      fetch(url)
      .then(response => {
          const contentType = response.headers.get("content-type");
          let fileExtension = "";
          if (contentType.includes("application")) {
            fileExtension = contentType.split("/")[1];
          } else if (contentType.includes("image")) {
            fileExtension = contentType.split("/")[1];
          }
          return response.arrayBuffer().then(buffer => ({ buffer, extension: fileExtension }));
      })
      .then(({buffer, extension}) => {
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${name}.${extension}`); // 替换为期望的下载文件名
        document.body.appendChild(link);
        link.click();
        this.classList.remove('active');
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch(error => {
        console.error('Error fetching the file:', error);
      });   
    }
    // downloadClick() {
    //   this.addEventListener('click', (e)=>{
    //     e.preventDefault();
    //     if(this.getAttribute('data-download-url') != '' && this.getAttribute('data-file-name') != '#') {
    //       console.log(this.getAttribute('data-download-url'),this.getAttribute('data-file-name'));
          
    //       this.fileDownload(this.getAttribute('data-download-url'),this.getAttribute('data-file-name'))
    //     }
    //   });
    // }

    handleDownloadClick(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const downloadUrl = this.getAttribute('data-download-url');
      const fileName = this.getAttribute('data-file-name');
      
      if (downloadUrl && fileName && fileName !== '#') {
        console.log('Download URL:', downloadUrl, 'File Name:', fileName);
        this.fileDownload(downloadUrl, fileName);
      }
    }
  }
  if (!window.customElements.get('yg-download')) {
    window.customElements.define('yg-download', YGDownload);
  }
});

